/* =========================================================
   SecretGleam V3 — Interactions
   Fade+translate au scroll, accordéon FAQ, slider d'avis
   (auto-scroll lent), comparateur avant/après draggable.
   Vanilla JS, sans dépendance externe.
   ========================================================= */

(function () {
  "use strict";

  document.documentElement.classList.add("v3-js");

  /* ---------- 1) Reveal au scroll ---------- */
  function initReveal() {
    var items = document.querySelectorAll(".v3-reveal");
    if (!items.length) return;

    if (!("IntersectionObserver" in window)) {
      items.forEach(function (el) { el.classList.add("v3-in"); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("v3-in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -8% 0px" }
    );

    items.forEach(function (el) { io.observe(el); });
  }
  /* ---------- 2) Accordéon FAQ (une seule réponse ouverte) ---------- */
  function initAccordions() {
    var groups = document.querySelectorAll("[data-v3-accordion]");
    groups.forEach(function (group) {
      var items = group.querySelectorAll(".v3-faq-item");
      items.forEach(function (item) {
        var trigger = item.querySelector(".v3-faq-question");
        var panel = item.querySelector(".v3-faq-answer");
        if (!trigger || !panel) return;

        trigger.addEventListener("click", function () {
          var isOpen = item.classList.contains("v3-open");

          items.forEach(function (other) {
            other.classList.remove("v3-open");
            var otherPanel = other.querySelector(".v3-faq-answer");
            var otherTrigger = other.querySelector(".v3-faq-question");
            if (otherPanel) otherPanel.style.maxHeight = null;
            if (otherTrigger) otherTrigger.setAttribute("aria-expanded", "false");
          });

          if (!isOpen) {
            item.classList.add("v3-open");
            trigger.setAttribute("aria-expanded", "true");
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
        });
      });
    });

    // Recalcule les hauteurs ouvertes au resize (texte qui se reflow)
    window.addEventListener("resize", function () {
      document.querySelectorAll(".v3-faq-item.v3-open .v3-faq-answer").forEach(function (panel) {
        panel.style.maxHeight = panel.scrollHeight + "px";
      });
    });
  }
  /* ---------- 3) Slider d'avis — auto-scroll lent + contrôles ---------- */
  function initReviewSliders() {
    var sliders = document.querySelectorAll("[data-v3-review-slider]");
    sliders.forEach(function (slider) {
      var track = slider.querySelector(".v3-reviews-track");
      if (!track) return;

      var prevBtn = slider.querySelector("[data-v3-prev]");
      var nextBtn = slider.querySelector("[data-v3-next]");
      var speed = parseFloat(slider.getAttribute("data-speed")) || 0.4;
      var isHover = false;
      var isDown = false;
      var raf = null;

      function step() {
        if (!isHover && !isDown) {
          track.scrollLeft += speed;
          if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 1) {
            track.scrollLeft = 0;
          }
        }
        raf = requestAnimationFrame(step);
      }

      if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        raf = requestAnimationFrame(step);
      }

      slider.addEventListener("mouseenter", function () { isHover = true; });
      slider.addEventListener("mouseleave", function () { isHover = false; });

      function cardWidth() {
        var card = track.querySelector(".v3-review-card");
        return card ? card.getBoundingClientRect().width + 20 : 320;
      }

      if (nextBtn) {
        nextBtn.addEventListener("click", function () {
          track.scrollBy({ left: cardWidth(), behavior: "smooth" });
        });
      }
      if (prevBtn) {
        prevBtn.addEventListener("click", function () {
          track.scrollBy({ left: -cardWidth(), behavior: "smooth" });
        });
      }
    });
  }
  /* ---------- 4) Comparateur Avant / Après (curseur draggable) ---------- */
  function initBeforeAfter() {
    var widgets = document.querySelectorAll("[data-v3-before-after]");
    widgets.forEach(function (widget) {
      var afterPane = widget.querySelector(".v3-ba-after");
      var handle = widget.querySelector(".v3-ba-handle");
      if (!afterPane || !handle) return;

      var dragging = false;

      function setPosition(clientX) {
        var rect = widget.getBoundingClientRect();
        var x = clientX - rect.left;
        var pct = Math.min(100, Math.max(0, (x / rect.width) * 100));
        afterPane.style.width = pct + "%";
        handle.style.left = pct + "%";
        widget.setAttribute("aria-valuenow", Math.round(pct));
      }

      function start(e) {
        dragging = true;
        widget.classList.add("v3-ba-dragging");
        move(e);
      }
      function move(e) {
        if (!dragging) return;
        var clientX = e.touches ? e.touches[0].clientX : e.clientX;
        setPosition(clientX);
      }
      function end() {
        dragging = false;
        widget.classList.remove("v3-ba-dragging");
      }

      handle.addEventListener("mousedown", start);
      window.addEventListener("mousemove", move);
      window.addEventListener("mouseup", end);

      handle.addEventListener("touchstart", start, { passive: true });
      window.addEventListener("touchmove", move, { passive: true });
      window.addEventListener("touchend", end);

      // Clic direct sur l'image pour déplacer le curseur
      widget.addEventListener("click", function (e) {
        if (e.target === handle || handle.contains(e.target)) return;
        setPosition(e.clientX);
      });

      // Clavier (accessibilité)
      handle.setAttribute("tabindex", "0");
      widget.setAttribute("role", "slider");
      widget.setAttribute("aria-valuemin", "0");
      widget.setAttribute("aria-valuemax", "100");
      handle.addEventListener("keydown", function (e) {
        var rect = widget.getBoundingClientRect();
        var current = parseFloat(afterPane.style.width) || 50;
        if (e.key === "ArrowLeft") { setPosition(rect.left + (rect.width * (current - 5) / 100)); }
        if (e.key === "ArrowRight") { setPosition(rect.left + (rect.width * (current + 5) / 100)); }
      });

      // Position initiale
      setPosition(widget.getBoundingClientRect().left + widget.getBoundingClientRect().width / 2);
    });
  }

  function init() {
    initReveal();
    initAccordions();
    initReviewSliders();
    initBeforeAfter();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
